<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <form @submit.prevent="submitForm()">
        <div class="join container">
          <div class="joinTitle">
            <h3>비밀번호변경</h3>
          </div>
          <div class="joinContext userInput other">
            <div class="warnSpace">
              <p class="warn"  v-text="form.password.errorTxt" v-if="form.password.hasError"></p>
            </div>
            <div class="article require"  :class="{errorLaise : form.password.hasError}">
              <div class="inputHeader">
                <p>현재비밀번호</p>
              </div>
              <input  type="password" v-model="form.password.value" maxlength="20" @keyup="blurPassword()" placeholder="현재 비밀번호를 입력해주세요." class="pwInput" />
            </div>
            <div class="warnSpace">
              <p class="warn"  v-text="form.newPassword.errorTxt" v-if="form.newPassword.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.newPassword.hasError}">
              <div class="inputHeader">
                <p>새 비밀번호 입력</p>
              </div>
              <input  type="password" v-model="form.newPassword.value" maxlength="20" @keyup="blurNewPassword()"  placeholder="비밀번호를 입력해주세요." class="newPwInput"/>
            </div>
            <div class="warnSpace">
              <p class="warn"  v-text="form.newPasswordConfirm.errorTxt" v-if="form.newPasswordConfirm.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.newPasswordConfirm.hasError}">
              <div class="inputHeader">
                <p>새 비밀번호 확인</p>
              </div>
              <input  type="password" v-model="form.newPasswordConfirm.value" maxlength="20" @keyup="blurNewPasswordConfirm()" placeholder="비밀번호 확인을 입력해주세요." class="newPwConfirmInput"/>
            </div>
          </div>
        </div>
        <div class="btnWrap" :class="{visible : form.password.flag && form.newPassword.flag && form.newPasswordConfirm.flag  }">
          <button type="submit">확인</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호변경',
        prevUrl: '/controllSetting'
      },
      form: {
        password: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        newPassword: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        newPasswordConfirm: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      view: {
        errorMsg: ''
      },
      setCount: false
    }
  },
  created () {
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('confirmPassword') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.checkInfo()
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  methods: {
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/modifyUser/confirmPassword')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    checkInfo () {
      const getValue = this.$store.getters.GET_CHECKED_PW
      if (!getValue) {
        this.SET_POPUP(true)
        this.popupSet.content = '다시 진행해주세요.'
        this.popupSet.count = 'another'
        this.popupSet.nextLink = '/modifyUser/confirmPassword'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/modifyUser/confirmPassword'
      } else {
        console.log('비밀번호 체크하고 진입함')
      }
    },
    blurPassword () {
      this.form.password.flag = false
      this.checkPassword()
    },
    checkPassword () {
      if (this.form.password.flag) return true
      const password = this.form.password.value
      if (password === '') {
        this.form.password.hasError = true
        this.form.password.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      // const isPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,15}/
      // if (!isPw.test(password)) {
      //   this.form.password.hasError = true
      //   this.form.password.flag = false
      //   this.form.password.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~15자를 설정해주세요.'
      //   return false
      // }
      this.form.password.flag = true
      this.form.password.hasError = false
      this.form.password.errorTxt = ''
      return true
    },
    blurNewPassword () {
      this.form.newPassword.flag = false
      this.checkNewPassword()
    },
    checkNewPassword () {
      if (this.form.newPassword.flag) return true
      const newPassword = this.form.newPassword.value
      if (newPassword === '') {
        this.form.newPassword.hasError = true
        this.form.newPassword.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      const isPw = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$/
      if (!isPw.test(newPassword)) {
        this.form.newPassword.hasError = true
        this.form.newPassword.flag = false
        this.form.newPassword.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~20자를 설정해주세요.'
        return false
      }
      this.form.newPassword.flag = true
      this.form.newPassword.hasError = false
      this.form.newPassword.errorTxt = ''
      return true
    },
    blurNewPasswordConfirm () {
      this.form.newPasswordConfirm.flag = false
      this.checkNewPasswordConfirm()
    },
    checkNewPasswordConfirm () {
      if (this.form.newPasswordConfirm.flag) return true
      const newPasswordConfirm = this.form.newPasswordConfirm.value
      if (newPasswordConfirm === '') {
        this.form.newPasswordConfirm.hasError = true
        this.form.newPasswordConfirm.errorTxt = '비밀번호 확인을 입력해주세요.'
        return false
      }
      if (newPasswordConfirm !== this.form.newPassword.value) {
        this.form.newPasswordConfirm.flag = false
        this.form.newPasswordConfirm.hasError = true
        this.form.newPasswordConfirm.errorTxt = '비밀번호가 일치하지 않습니다.'
        return false
      }
      this.form.newPasswordConfirm.flag = true
      this.form.newPasswordConfirm.hasError = false
      this.form.newPasswordConfirm.errorTxt = ''
      return true
    },
    checkAll () {
      return !!(this.form.password.flag && this.form.newPassword.flag &&
        this.form.newPasswordConfirm.flag)
    },
    submitForm () {
      if (this.checkAll()) {
        this.checkPw()
      } else {
        if (!this.form.password.flag) {
          this.popupSet.content = '현재 비밀번호를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.password.hasError = true
          this.form.password.errorTxt = '현재 비밀번호를 확인해주세요.'
          // document.querySelector('.pwInput').focus()
        } else if (!this.form.newPassword.flag) {
          this.popupSet.content = '새 비밀번호를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.newPassword.hasError = true
          this.form.newPassword.errorTxt = '새 비밀번호를 확인해주세요.'
          // document.querySelector('.newPwInput').focus()
        } else if (!this.form.newPassword.flag || !this.form.newPasswordConfirm.flag) {
          this.popupSet.content = '비밀번호 확인이 일치하지 않습니다.'
          this.SET_POPUP(true)
          this.form.newPasswordConfirm.hasError = true
          this.form.newPasswordConfirm.errorTxt = '비밀번호 확인이 일치하지 않습니다.'
          // document.querySelector('.newPwConfirmInput').focus()
        }
      }
    },
    async checkPw () {
      try {
        const userData = {
          password: this.form.password.value
        }
        await this.CHECK_PW(userData)
          .then(() => {
            this.form.password.flag = true
            this.form.password.hasError = false
            this.form.password.errorTxt = ''
            this.changePassword()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('체크리스트 디테일 에러에 진입함!')
        if (error.status !== 401) {
          if (error.data.response.message === 'Invalid Password') {
            this.SET_POPUP(true)
            this.popupSet.content = '현재 비밀번호를 확인해주세요.'
            this.form.password.hasError = true
            this.form.password.errorTxt = '현재 비밀번호를 확인해주세요.'
          } else {
            this.SET_POPUP(true)
            this.popupSet.content = '다시 입력해주세요.'
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.form.password.value = ''
      }
    },
    async changePassword () {
      try {
        const userData = {
          originPassword: this.form.password.value,
          newPassword: this.form.newPassword.value,
          confirmPassword: this.form.newPasswordConfirm.value
        }
        await this.CHANGE_PW(userData)
          .then(() => {
            this.SET_POPUP(true)
            this.popupSet.count = 'another'
            this.popupSet.content = '비밀번호가 변경되었습니다.'
            this.popupSet.nextLink = '/'
            this.popupSet.closeType = 'action'
            this.popupSet.closeLink = '/'
          })
      } catch (error) {
        console.log('error :', error);
        console.log('비밀번호 변경 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = '비밀번호를 다시 확인해주세요.'
        } else {
          await this.$router.push('/login')
        }
        // this.popupSet.content = errorParser.parse(error)
        // console.log('에러메시지', error.response.data.response.message)
        // this.popupSet.content = ''
        // error.response.data.response.message = this.view.errorMsg
        // this.view.errorMsg = this.popupSet.content
      } finally {
        this.initForm()
      }
    },
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'CHANGE_PW',
      'CHECK_PW'
    ]),
    initForm () {
      this.form.password.value = ''
      this.form.newPassword.value = ''
      this.form.newPasswordConfirm.value = ''
      this.form.password.flag = false
      this.form.newPassword.flag = false
      this.form.newPasswordConfirm.flag = false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>
<style lang="scss" scoped>
  .join .joinContext .article.require .inputHeader p {
    min-width:100px;
  }
</style>
